import Vue from 'vue'
export const JustDigits = () => {
  Vue.directive('digitsonly', (el, binding) => {
    let numberOfComa = el.value.split('.').length - 1
    if (/[^\d.]/g.test(el.value) === false && numberOfComa < 2) {
      console.log('ok: ' + el.value + ' , ' + numberOfComa)
    } else {
      el.value = ''
      binding.value = el.value
    }
  })
}



// WEBPACK FOOTER //
// ./src/assets/digitsonly.js